import React, { useState, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import PopularFlightRoutesCard from "components/PopularFlightRoutesCard/PopularFlightRoutesCard";
import { indiaGate } from "Utils/Images"; // Use your actual image paths
import { NewYork } from "Utils/Images";
import { LosAngeles } from "Utils/Images";
import { Chicago } from "Utils/Images";
import { Montreal } from "Utils/Images";
import { CalgaryTower } from "Utils/Images";
import { Vancouver } from "Utils/Images";
import { cntower } from "Utils/Images";
import { Miami } from "Utils/Images";
import { hollywood } from "Utils/Images";
import { Houston } from "Utils/Images";
import { WillisTower } from "Utils/Images";

export default function PopularFlightRoutes() {
  const [showAll, setShowAll] = useState(false);

  // Array of flight route data
  const flightRoutes = [
    {
      title: "Toronto Flights",
      imageSrc: cntower,
      destinations: [
        { name: "Amritsar", url: "/flights/toronto-amritsar" },
        { name: "Delhi", url: "/flights/toronto-delhi" },
        { name: "Mumbai", url: "/flights/toronto-mumbai" },
        { name: "Chennai", url: "/flights/toronto-chennai" },
        { name: "Kolkata", url: "/flights/toronto-kolkata" },
      ],
      content: {
        description:
          "Fly from Toronto Pearson International Airport (YYZ) to top Indian cities with comfort and convenience. Take advantage of seasonal offers, in-flight entertainment, and flexible layovers.",
        airlines: ["Air Canada", "Lufthansa", "Emirates", "Qatar Airways"],
        images: [
          "/images/toronto/toronto-airport.jpg",
          "/images/toronto/toronto-flight-deal.jpg",
          "/images/toronto/toronto-inflight.jpg",
        ],
        averageFlightDuration: {
          Amritsar: "15h 30m (1 stop)",
          Delhi: "14h 45m (non-stop / 1 stop)",
          Mumbai: "15h 20m (1 stop)",
          Chennai: "16h 10m (1 stop)",
          Kolkata: "15h 50m (1 stop)",
        },
        priceRangeUSD: {
          Amritsar: "$950 – $1,350",
          Delhi: "$900 – $1,300",
          Mumbai: "$920 – $1,320",
          Chennai: "$980 – $1,380",
          Kolkata: "$970 – $1,370",
        },
        flightsPerWeek: {
          Amritsar: "7–10",
          Delhi: "10–12",
          Mumbai: "8–11",
          Chennai: "5–7",
          Kolkata: "5–6",
        },
        bestTimeToTravel:
          "October to March (pleasant weather in Northern India)",
        topAttractions: {
          Toronto: ["CN Tower", "Ripley’s Aquarium", "Distillery District"],
          Delhi: ["Red Fort", "Qutub Minar", "India Gate"],
          Mumbai: ["Gateway of India", "Elephanta Caves", "Marine Drive"],
          Kolkata: [
            "Victoria Memorial",
            "Howrah Bridge",
            "Dakshineswar Kali Temple",
          ],
          Chennai: ["Marina Beach", "Kapaleeshwarar Temple", "Fort St. George"],
          Amritsar: ["Golden Temple", "Jallianwala Bagh", "Wagah Border"],
        },
        tips: [
          "Book at least 2–3 months in advance to lock in lower fares.",
          "Look for 1-stop options via Frankfurt or Doha for slightly cheaper tickets.",
          "Carry a power bank and universal adapter—aircraft USB ports may vary.",
        ],
      },
    },
    {
      title: "Montreal Flights",
      imageSrc: Montreal,
      destinations: [
        { name: "Amritsar", url: "/flights/montreal-amritsar" },
        { name: "Delhi", url: "/flights/montreal-delhi" },
        { name: "Mumbai", url: "/flights/montreal-mumbai" },
        { name: "Chennai", url: "/flights/montreal-chennai" },
        { name: "Kolkata", url: "/flights/montreal-kolkata" },
      ],
      content: {
        description:
          "Discover both nonstop and one-stop flights out of Montréal–Trudeau (YUL) to India. Enjoy competitive fares and premium lounges during layovers.",
        airlines: [
          "British Airways",
          "Air France",
          "Qatar Airways",
          "Etihad Airways",
        ],
        images: [
          "/images/montreal/montreal-airport.jpg",
          "/images/montreal/montreal-comfort-seating.jpg",
          "/images/montreal/montreal-premium-checkin.jpg",
        ],
        averageFlightDuration: {
          Amritsar: "16h 10m (1 stop)",
          Delhi: "15h 30m (1 stop)",
          Mumbai: "15h 55m (1 stop)",
          Chennai: "17h 00m (1 stop)",
          Kolkata: "16h 40m (1 stop)",
        },
        priceRangeUSD: {
          Amritsar: "$980 – $1,400",
          Delhi: "$950 – $1,380",
          Mumbai: "$970 – $1,390",
          Chennai: "$1,020 – $1,420",
          Kolkata: "$1,010 – $1,410",
        },
        flightsPerWeek: {
          Amritsar: "5–7",
          Delhi: "8–10",
          Mumbai: "6–8",
          Chennai: "4–6",
          Kolkata: "4–5",
        },
        bestTimeToTravel: "November to February (dry season in most of India)",
        topAttractions: {
          Montreal: ["Old Montreal", "Mount Royal", "Notre-Dame Basilica"],
          Delhi: ["Humayun’s Tomb", "Lotus Temple", "Chandni Chowk"],
        },
        tips: [
          "Consider early-morning departures to avoid jet lag.",
          "Check baggage allowances—some European carriers have stricter limits.",
          "Download airline apps for real-time gate changes and boarding notifications.",
        ],
      },
    },
    {
      title: "Calgary Flights",
      imageSrc: CalgaryTower,
      destinations: [
        { name: "Amritsar", url: "/flights/calgary-amritsar" },
        { name: "Delhi", url: "/flights/calgary-delhi" },
        { name: "Mumbai", url: "/flights/calgary-mumbai" },
        { name: "Chennai", url: "/flights/calgary-chennai" },
        { name: "Kolkata", url: "/flights/calgary-kolkata" },
      ],
      content: {
        description:
          "Choose from several major carriers flying out of Calgary International (YYC) to India. Ideal for connecting through Europe or the Middle East.",
        airlines: ["Air Canada", "KLM", "Turkish Airlines"],
        images: [
          "/images/calgary/calgary-departure-lounge.jpg",
          "/images/calgary/calgary-flight-map.jpg",
          "/images/calgary/calgary-meal-service.jpg",
        ],
        averageFlightDuration: {
          Amritsar: "17h 20m (1 stop)",
          Delhi: "16h 45m (1 stop)",
          Mumbai: "17h 10m (1 stop)",
          Chennai: "18h 00m (1 stop)",
          Kolkata: "17h 45m (1 stop)",
        },
        priceRangeUSD: {
          Amritsar: "$1,000 – $1,450",
          Delhi: "$980 – $1,420",
          Mumbai: "$995 – $1,430",
          Chennai: "$1,050 – $1,480",
          Kolkata: "$1,040 – $1,470",
        },
        flightsPerWeek: {
          Amritsar: "4–6",
          Delhi: "6–8",
          Mumbai: "5–7",
          Chennai: "3–5",
          Kolkata: "3–4",
        },
        bestTimeToTravel:
          "September to December (pleasant autumn/fall in India)",
        topAttractions: {
          Calgary: ["Banff National Park", "Calgary Stampede", "Heritage Park"],
          Delhi: ["Akshardham", "Red Fort", "Jama Masjid"],
        },
        tips: [
          "If you have a long layover in Amsterdam, take advantage of KLM’s city tours for transit passengers.",
          "Calgary’s airport lounges offer complimentary snacks—arrive early to use them.",
          "Pack a light jacket for cooler first-leg flights in autumn/winter.",
        ],
      },
    },
    {
      title: "Vancouver Flights",
      imageSrc: Vancouver,
      destinations: [
        { name: "Amritsar", url: "/flights/vancouver-amritsar" },
        { name: "Delhi", url: "/flights/vancouver-delhi" },
        { name: "Mumbai", url: "/flights/vancouver-mumbai" },
        { name: "Chennai", url: "/flights/vancouver-chennai" },
        { name: "Kolkata", url: "/flights/vancouver-kolkata" },
      ],
      content: {
        description:
          "Non-stop and one-stop flights to India from Vancouver International Airport (YVR). Enjoy award-winning lounges and premium in-flight service.",
        airlines: ["Singapore Airlines", "Cathay Pacific", "Qatar Airways"],
        images: [
          "/images/vancouver/vancouver-airlines.jpg",
          "/images/vancouver/vancouver-cabin.jpg",
          "/images/vancouver/vancouver-boarding.jpg",
        ],
        averageFlightDuration: {
          Amritsar: "17h 45m (1 stop)",
          Delhi: "17h 10m (1 stop)",
          Mumbai: "17h 40m (1 stop)",
          Chennai: "18h 30m (1 stop)",
          Kolkata: "18h 10m (1 stop)",
        },
        priceRangeUSD: {
          Amritsar: "$1,020 – $1,480",
          Delhi: "$1,000 – $1,450",
          Mumbai: "$1,015 – $1,470",
          Chennai: "$1,060 – $1,520",
          Kolkata: "$1,050 – $1,510",
        },
        flightsPerWeek: {
          Amritsar: "5–7",
          Delhi: "7–9",
          Mumbai: "6–8",
          Chennai: "4–6",
          Kolkata: "4–5",
        },
        bestTimeToTravel:
          "October to March (cooler months in Canada, warmer in India)",
        topAttractions: {
          Vancouver: [
            "Stanley Park",
            "Granville Island",
            "Capilano Suspension Bridge",
          ],
          Mumbai: ["Gateway of India", "Marine Drive", "Elephanta Caves"],
        },
        tips: [
          "Vancouver’s airport has fast Wi-Fi—download movies before boarding your flight.",
          "Singapore Airlines often has promo sales in late spring (April–May).",
          "Use a VPN on layovers in certain countries if you want uninterrupted streaming in-flight.",
        ],
      },
    },
    {
      title: "New York Flights",
      imageSrc: NewYork,
      destinations: [
        { name: "Amritsar", url: "/flights/new-york-amritsar" },
        { name: "Delhi", url: "/flights/new-york-delhi" },
        { name: "Mumbai", url: "/flights/new-york-mumbai" },
        { name: "Chennai", url: "/flights/new-york-chennai" },
        { name: "Kolkata", url: "/flights/new-york-kolkata" },
      ],
      content: {
        description:
          "Book low-cost or premium flights from JFK/EWR to major Indian destinations. Multiple daily options on US and Middle Eastern carriers.",
        airlines: [
          "United Airlines",
          "Emirates",
          "Etihad Airways",
          "British Airways",
        ],
        images: [
          "/images/newyork/jfk-terminal.jpg",
          "/images/newyork/business-class.jpg",
          "/images/newyork/newyork-special-offer.jpg",
        ],
        averageFlightDuration: {
          Amritsar: "16h 00m (1 stop)",
          Delhi: "15h 20m (non-stop / 1 stop)",
          Mumbai: "15h 50m (1 stop)",
          Chennai: "16h 40m (1 stop)",
          Kolkata: "16h 30m (1 stop)",
        },
        priceRangeUSD: {
          Amritsar: "$930 – $1,350",
          Delhi: "$900 – $1,320",
          Mumbai: "$920 – $1,340",
          Chennai: "$960 – $1,380",
          Kolkata: "$950 – $1,370",
        },
        flightsPerWeek: {
          Amritsar: "8–10",
          Delhi: "12–15",
          Mumbai: "10–12",
          Chennai: "6–8",
          Kolkata: "6–7",
        },
        bestTimeToTravel: "September to November (post-monsoon, pre-winter)",
        topAttractions: {
          NewYork: ["Times Square", "Statue of Liberty", "Central Park"],
          Delhi: ["Jama Masjid", "India Gate", "Raj Ghat"],
        },
        tips: [
          "For cheaper fares, avoid booking in December–January holiday season.",
          "If you have a long layover in Dubai, Emirates often provides free city tours.",
          "Check visa transit requirements if you have a layover exceeding 8 hours.",
        ],
      },
    },
    {
      title: "Miami Flights",
      imageSrc: Miami,
      destinations: [
        { name: "Amritsar", url: "/flights/miami-amritsar" },
        { name: "Delhi", url: "/flights/miami-delhi" },
        { name: "Mumbai", url: "/flights/miami-mumbai" },
        { name: "Chennai", url: "/flights/miami-chennai" },
        { name: "Kolkata", url: "/flights/miami-kolkata" },
      ],
      content: {
        description:
          "Connect from Miami Intl. (MIA) to India via European or Middle Eastern hubs. Mix tropical vacation vibes with your long-haul trip.",
        airlines: [
          "Qatar Airways",
          "Turkish Airlines",
          "Delta Airlines",
          "Air France",
        ],
        images: [
          "/images/miami/miami-gate.jpg",
          "/images/miami/miami-crew.jpg",
          "/images/miami/miami-inflight-view.jpg",
        ],
        averageFlightDuration: {
          Amritsar: "16h 50m (1 stop)",
          Delhi: "16h 15m (1 stop)",
          Mumbai: "16h 45m (1 stop)",
          Chennai: "17h 30m (1 stop)",
          Kolkata: "17h 10m (1 stop)",
        },
        priceRangeUSD: {
          Amritsar: "$970 – $1,420",
          Delhi: "$950 – $1,400",
          Mumbai: "$960 – $1,410",
          Chennai: "$1,000 – $1,450",
          Kolkata: "$990 – $1,440",
        },
        flightsPerWeek: {
          Amritsar: "6–8",
          Delhi: "8–10",
          Mumbai: "7–9",
          Chennai: "5–6",
          Kolkata: "5–6",
        },
        bestTimeToTravel:
          "January to April (dry season in India, mild in Florida)",
        topAttractions: {
          Miami: ["South Beach", "Wynwood Walls", "Little Havana"],
          Mumbai: [
            "Colaba Causeway",
            "Chhatrapati Shivaji Terminus",
            "Juhu Beach",
          ],
        },
        tips: [
          "Miami’s airport offers free hotel shuttles for long layovers—check with your carrier.",
          "Turkish Airlines often has competitive round-trip fares if routed via Istanbul.",
          "Pack sunscreen for connecting flights if you plan to stroll around Miami on a layover.",
        ],
      },
    },
    {
      title: "Los Angeles Flights",
      imageSrc: hollywood,
      destinations: [
        { name: "Amritsar", url: "/flights/los-angeles-amritsar" },
        { name: "Delhi", url: "/flights/los-angeles-delhi" },
        { name: "Mumbai", url: "/flights/los-angeles-mumbai" },
        { name: "Chennai", url: "/flights/los-angeles-chennai" },
        { name: "Kolkata", url: "/flights/los-angeles-kolkata" },
      ],
      content: {
        description:
          "Fly from LAX with world-renowned carriers. Whether you want a nonstop to Delhi or a one-stop through the Middle East, LA offers it all.",
        airlines: ["ANA", "Qatar Airways", "Air India", "United Airlines"],
        images: [
          "/images/la/la-runway.jpg",
          "/images/la/la-travel-kit.jpg",
          "/images/la/la-destination-board.jpg",
        ],
        averageFlightDuration: {
          Amritsar: "17h 00m (1 stop)",
          Delhi: "16h 30m (1 stop)",
          Mumbai: "17h 05m (1 stop)",
          Chennai: "18h 00m (1 stop)",
          Kolkata: "17h 40m (1 stop)",
        },
        priceRangeUSD: {
          Amritsar: "$1,000 – $1,480",
          Delhi: "$980 – $1,450",
          Mumbai: "$995 – $1,470",
          Chennai: "$1,040 – $1,510",
          Kolkata: "$1,030 – $1,500",
        },
        flightsPerWeek: {
          Amritsar: "7–9",
          Delhi: "9–11",
          Mumbai: "8–10",
          Chennai: "6–8",
          Kolkata: "6–7",
        },
        bestTimeToTravel: "December to February (mild in LA, winter in India)",
        topAttractions: {
          LosAngeles: [
            "Hollywood Sign",
            "Griffith Observatory",
            "Santa Monica Pier",
          ],
          Chennai: ["Marina Beach", "Kapaleeshwarar Temple", "Fort St. George"],
        },
        tips: [
          "If flying ANA, check for layover perks in Tokyo if you have a longer connection.",
          "LAX traffic can be heavy—arrive 3 hours early for international departures.",
          "Pack noise-canceling headphones—some long-haul flights use older in-flight entertainment systems.",
        ],
      },
    },
    {
      title: "Chicago Flights",
      imageSrc: WillisTower,
      destinations: [
        { name: "Amritsar", url: "/flights/chicago-amritsar" },
        { name: "Delhi", url: "/flights/chicago-delhi" },
        { name: "Mumbai", url: "/flights/chicago-mumbai" },
        { name: "Chennai", url: "/flights/chicago-chennai" },
        { name: "Kolkata", url: "/flights/chicago-kolkata" },
      ],
      content: {
        description:
          "Travel from O’Hare International (ORD) to India with multiple daily options on major carriers. Flexible layover airports include Doha, Frankfurt, and Istanbul.",
        airlines: ["Air India", "American Airlines", "KLM", "Turkish Airlines"],
        images: [
          "/images/chicago/chicago-ticket-counter.jpg",
          "/images/chicago/chicago-boarding-pass.jpg",
          "/images/chicago/chicago-window-view.jpg",
        ],
        averageFlightDuration: {
          Amritsar: "15h 40m (non-stop / 1 stop)",
          Delhi: "15h 00m (non-stop / 1 stop)",
          Mumbai: "15h 30m (1 stop)",
          Chennai: "16h 20m (1 stop)",
          Kolkata: "16h 00m (1 stop)",
        },
        priceRangeUSD: {
          Amritsar: "$920 – $1,340",
          Delhi: "$900 – $1,320",
          Mumbai: "$910 – $1,330",
          Chennai: "$950 – $1,370",
          Kolkata: "$940 – $1,360",
        },
        flightsPerWeek: {
          Amritsar: "9–11",
          Delhi: "11–13",
          Mumbai: "10–12",
          Chennai: "7–9",
          Kolkata: "7–8",
        },
        bestTimeToTravel:
          "April to June (pre-monsoon, pleasant weather in India)",
        topAttractions: {
          Chicago: ["Millennium Park", "Willis Tower Skydeck", "Navy Pier"],
          Mumbai: [
            "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
            "Haji Ali Dargah",
            "Fashion Street",
          ],
        },
        tips: [
          "American Airlines often has off-peak fare sales in March and September.",
          "ORD’s international terminal has numerous lounges—consider day passes if layover is long.",
          "Keep an eye on weather—ORD can experience spring storms that delay flights.",
        ],
      },
    },
    {
      title: "Houston Flights",
      imageSrc: Houston,
      destinations: [
        { name: "Amritsar", url: "/flights/houston-amritsar" },
        { name: "Delhi", url: "/flights/houston-delhi" },
        { name: "Mumbai", url: "/flights/houston-mumbai" },
        { name: "Chennai", url: "/flights/houston-chennai" },
        { name: "Kolkata", url: "/flights/houston-kolkata" },
      ],
      content: {
        description:
          "Book flights from George Bush Intercontinental (IAH) to India with convenient one-stop connections through Doha, Dubai, or London. Enjoy premium lounges and fast-track immigration options.",
        airlines: [
          "Emirates",
          "United Airlines",
          "Qatar Airways",
          "British Airways",
        ],
        images: [
          "/images/houston/houston-checkin.jpg",
          "/images/houston/houston-flight-crew.jpg",
          "/images/houston/houston-destination-sign.jpg",
        ],
        averageFlightDuration: {
          Amritsar: "16h 20m (1 stop)",
          Delhi: "15h 45m (1 stop)",
          Mumbai: "16h 10m (1 stop)",
          Chennai: "17h 00m (1 stop)",
          Kolkata: "16h 40m (1 stop)",
        },
        priceRangeUSD: {
          Amritsar: "$980 – $1,430",
          Delhi: "$960 – $1,410",
          Mumbai: "$970 – $1,420",
          Chennai: "$1,010 – $1,460",
          Kolkata: "$1,000 – $1,450",
        },
        flightsPerWeek: {
          Amritsar: "7–9",
          Delhi: "9–11",
          Mumbai: "8–10",
          Chennai: "6–8",
          Kolkata: "6–7",
        },
        bestTimeToTravel:
          "February to May (springtime in India, moderate weather in Texas)",
        topAttractions: {
          Houston: [
            "Space Center Houston",
            "Houston Museum District",
            "Buffalo Bayou Park",
          ],
          Kolkata: [
            "Victoria Memorial",
            "Howrah Bridge",
            "Dakshineswar Kali Temple",
          ],
        },
        tips: [
          "Emirates’ codeshare with United can sometimes yield cheaper combined tickets.",
          "United’s Polaris Lounge at IAH offers excellent sleeping pods if you have a long layover.",
          "Keep an eye on visa requirements for layover countries—some require transit visas for >8-hour layovers.",
        ],
      },
    },
  ];

  // Show only 9 cards by default
  const cardsToShow = showAll ? flightRoutes : flightRoutes.slice(0, 9);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const controls = useAnimation();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [inView, controls]);

  return (
    <section ref={ref} className="m-auto max-w-8xl px-5 sm:px-0">
      <motion.h4
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="text-xl sm:text-4xl"
      >
        Popular <span className="font-bold">Flight Routes</span>
      </motion.h4>
      <motion.div
        className="my-5 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-5 md:grid-cols-3"
        initial="hidden"
        animate={controls}
      >
        {cardsToShow.map((route, index) => (
          <motion.div
            key={index}
            custom={index}
            variants={{
              hidden: { opacity: 0, y: 50 },
              visible: (i) => ({
                opacity: 1,
                y: 0,
                transition: {
                  delay: i * 0.1, // Stagger effect
                  duration: 0.3, // Duration of each card animation
                },
              }),
            }}
            initial="hidden"
            animate="visible" // Change to animate="visible" to trigger animation
          >
            <PopularFlightRoutesCard
              title={route.title}
              imageSrc={route.imageSrc}
              destinations={route.destinations}
              content={route?.content}
            />
          </motion.div>
        ))}
      </motion.div>
      {/* {!showAll && (
        <motion.button
          className="mx-auto my-5 mt-0 block font-semibold text-red-600 sm:my-0 sm:mt-5"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => setShowAll(true)}
        >
          View More &#x2193;
        </motion.button>
      )} */}
    </section>
  );
}
